// extracted by mini-css-extract-plugin
export default {"projectInfo":"projects_projectInfo__dPTdK","container":"projects_container__QYAMD","projectContainer":"projects_projectContainer__H90tG"};